import {GroupMember} from './groups.datatypes';
import {BillingPartyMember} from './billing_party.datatypes';
import {PaymentSchedule} from './payment_schedule.datatypes';

export interface Payment {
    __typename?: string | undefined,
    id: number
    billing_party_member_id?: number
    room_party_member_id?: number
    amount?: number
    billing_party_amount?: number
    timestamp?: string
    payment_type?: number
    payment_status?: number
    provider_reference?: string | null
    provider_status?: string
    provider_response_raw?: string
    reconciled?: boolean
    assignedAmount?: number
    description?: string
    refunds_amount?: number
    cc_fee?: number

    billingPartyMember?: BillingPartyMember
    groupMemberPayments?: GroupMemberPayment[]
}

export interface AutomaticPayment {
    __typename?: string | undefined,
    id: number
    payment_token: string
    payment_type: number
    billing_party_member_id: number
    payment_frequency: number
    last_four: string
    routing_number: string
    paymentSchedule?: PaymentSchedule
}

export interface GroupMemberPayment {
    __typename?: string | undefined
    id: number
    payment_id: number
    group_member_id: number
    amount: number

    payment?: Payment
    groupMember?: GroupMember
}

export interface NexioResponse {
    status: string
    baseUrl?: string
    error?: string
    expiration?: string
    token?: string
    fraudUrl?: string
    data?: string
}

export interface CreditCardFee {
    __typename?: string | undefined
    id?: number,
    fee: string,
    type_id: number
    type: number
}

export interface CreditCardFee {
    id?: number,
    fee: string,
    type_id: number
    type: number
}

export interface CreditCardFee {
    id?: number,
    fee: string,
    type_id: number
    type: number
}

export interface CreditCardFee {
    id?: number,
    fee: string,
    type_id: number
    type: number
}

export const PaymentStatus = {
    PENDING: 0,
    COMPLETE: 1,
    REFUNDED: 2,
    FAILED: 3,
    CANCELLED: 4,
    VOIDED: 5,
};

export const PaymentStatuses = [
    {name: 'pending'},
    {name: 'complete'},
    {name: 'refunded'},
    {name: 'failed'},
    {name: 'cancelled'},
    {name: 'voided'},
];

export const PaymentType = {
    CARD: 0,
    ECHEQUE: 1,
    CASH: 2,
    BANK_TRANSFER: 3,
    CHEQUE: 4,
    PAYPAL: 5,
    CREDIT: 6,
    REFUND_NEXIO: 7,
    REFUND_CHECK: 8,
    TRANSFER: 9,
};

export const PaymentTypes = [
    {name: 'card'},
    {name: 'e-check'},
    {name: 'cash'},
    {name: 'wire transfer'},
    {name: 'check'},
    {name: 'paypal'},
    {name: 'credit'},
    {name: 'refund nexio'},
    {name: 'refund check'},
    {name: 'transfer'},
];

export const NexioPaymentTypes = {
    INIT_SCHEDULED: 'initialScheduled',
    INIT_UNSCHEDULED: 'initialUnscheduled',
    SCHEDULED: 'scheduled',
    UNSCHEDULED_CIT: 'unscheduledCit',
    UNSCHEDULED_MIT: 'unscheduledMit',
}

export const AutomaticPaymentFrequencies = [
    {
        value: 0,
        description: 'Pay according to Payment Schedule',
    },
]
